import { useTheme, Zoom } from "@mui/material";
import { lighten, styled } from "@mui/material/styles";
import { DatePicker } from "@mui/x-date-pickers";

import OmniTextField from "./omniTextField";

const CustomizedComponent = styled(DatePicker)(({ theme }) => ({
  marginTop: theme.spacing(1),
  "& .MuiInputBase-input": { padding: "8.5px", paddingLeft: "14px" },
}));

const OmniDatePicker = props => {
  const {
    id,
    children,
    format = "MM/dd/yyyy",
    onChange = null,
    label = "Missing",
    onAccept = null,
    showToolbar = false,
    showDaysOutsideCurrentMonth = false,
    value,
    required,
    error = false,
    ...other
  } = props;

  const theme = useTheme();

  return (
    <CustomizedComponent
      id={id}
      views={["year", "month", "day"]}
      variant="inline"
      label={label}
      value={value}
      inputVariant="outlined"
      color="secondary"
      margin="dense"
      format={format}
      fullWidth
      autoOk
      disablePortal
      showToolbar={showToolbar}
      showDaysOutsideCurrentMonth={showDaysOutsideCurrentMonth}
      required={required}
      PopperProps={{
        sx: {
          ".MuiButtonBase-root, .PrivatePickersYear-yearButton, .PrivatePickersMonth-root": {
            transform: "none",
            transformOrigin: "center",
            transition: "all 0.05s ease-out",
            "&:not(.Mui-selected)": {
              "&:hover": {
                backgroundColor: lighten(theme.palette.secondary.main, 0.75),
                color: theme.palette.secondary.main,
                ".MuiSvgIcon-root": {
                  fill: theme.palette.secondary.main,
                },
                "&:active": {
                  transform: "scale(0.925)",
                  boxShadow: `inset 0px 3px 1px -2px rgba(0,0,0,0.2), inset 0px 3px 4px 0px rgba(0,0,0,0.14), inset 0px 1px 8px 0px rgba(0,0,0,0.12)`,
                },
              },
            },
          },
          ".MuiButtonBase-root.Mui-selected, .PrivatePickersYear-yearButton.Mui-selected, .PrivatePickersMonth-root.Mui-selected":
            {
              backgroundColor: theme.palette.secondary.main,
              "&:hover": {
                backgroundColor: lighten(theme.palette.secondary.main, 0.65),
                color: theme.palette.secondary.main,
              },
            },
          "div[role=presentation]:hover": {
            color: theme.palette.secondary.main,
            ".MuiSvgIcon-root": {
              fill: theme.palette.secondary.main,
            },
          },
        },
      }}
      renderInput={props => <OmniTextField required={required} {...props} error={error} />}
      error
      onAccept={event => {
        if (onAccept != null) {
          onAccept(event);
        }
      }}
      onChange={event => {
        if (onChange != null) {
          onChange(event);
        }
      }}
      OpenPickerButtonProps={{
        position: "end",
      }}
      TransitionComponent={Zoom}
      {...other}
    />
  );
};

export default OmniDatePicker;
